import React, { useState } from 'react';
import { Copy, XLg, Check } from 'react-bootstrap-icons';
import figmaPluginImage from '../assets/figma-plugin.png';
import './FigmaIntegrationGuide.css';

interface FigmaIntegrationGuideProps {
  onClose: () => void;
  svgCode?: string;
}

const FigmaIntegrationGuide: React.FC<FigmaIntegrationGuideProps> = ({ onClose, svgCode }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyCode = async () => {
    if (!svgCode) {
      console.error('No SVG code available to copy');
      return;
    }

    try {
      await navigator.clipboard.writeText(svgCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
    }
  };
  return (
    <div className="figma-guide-overlay">
      <div className="figma-guide-panel">
        <div className="figma-guide-header">
          <h2 className="figma-guide-title">Figma Integration Guide</h2>
          <button className="figma-guide-close" onClick={onClose} aria-label="Close guide">
            <XLg size={16} />
          </button>
        </div>
        <div className="figma-guide-content">
          <div className="figma-guide-section">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <p>1. Download the <a href="https://www.figma.com/community/plugin/1574913680338868426/revealer-integration" target="_blank" rel="noreferrer" className="revealer-plugin-link">Revealer Integration Plugin</a></p>
          </div>

          <div className="figma-guide-section">
            <p>2. Your design artifact code has been copied to your clipboard. You may re-copy here if needed.</p>
            <div className="figma-code-box" onClick={handleCopyCode}>
              {copied ? <Check size={16} /> : <Copy size={16} />}
              {' '}
              {copied ? 'Copied!' : 'Click here to copy your design artifact code'}
            </div>
          </div>

          <div className="figma-guide-section">
            <p>3. Within Figma, go to the actions button at the bottom, then 'Plugins & widgets', then search for 'Revealer Integration', and run the plugin.</p>
          </div>

          <div className="figma-guide-section">
            <img src={figmaPluginImage} alt="Figma Plugin Interface" className="figma-plugin-image" />
          </div>

          <div className="figma-guide-section">
            <p>4. Paste the design artifact code into the text field and click 'Import'.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FigmaIntegrationGuide;
